const testimonials = [
    {
      id: 1,
      name: '',
      title: '',
      org: '',
      desc:
        'upcomming...',
    },
    {
      id: 2,
      name: '',
      title: '',
      org: '',
      desc:
        'upcomming...',
    },
    {
      id: 3,
      name: '',
      title: '',
      org: '',
      desc:
        'upcomming...',
    },
  ];
  export default testimonials;